import { Button, useTheme } from "@mui/material";
import { authFlowHeaderIcons } from "./authFlowHeaderIcons";
import {
  getLoginPrimaryButtonSx,
  LoginCardContent,
  LoginFormHeader,
} from "./loginUi";

export type PasswordResetCompleteProps = {
  loginUrl?: string;
  translations: {
    passwordResetComplete: string;
    passwordResetCompleteDescription: string;
    goToLogin: string;
  };
};

export const PasswordResetComplete = ({
  loginUrl = "/accounts/login/",
  translations: t,
}: PasswordResetCompleteProps) => {
  const theme = useTheme();

  return (
    <LoginCardContent testId="password-reset-complete">
      <LoginFormHeader
        title={t.passwordResetComplete}
        subtitle={t.passwordResetCompleteDescription}
        headerIcon={authFlowHeaderIcons.passwordResetComplete}
        headerTestId="password-reset-complete-header"
        titleTestId="password-reset-complete-title"
        headerIconTestId="password-reset-complete-header-icon"
      />

      <Button
        href={loginUrl}
        fullWidth
        variant="contained"
        size="large"
        data-testid="go-to-login-button"
        sx={getLoginPrimaryButtonSx(theme)}
      >
        {t.goToLogin}
      </Button>
    </LoginCardContent>
  );
};
